<nb-card class="delete-dialog">
  <nb-card-header>
    <morva-icons icon="close"
                 class="cursor-pointer icon-24 ms-2"
                 (click)="closeDialog()">
    </morva-icons>
    {{ title }}
  </nb-card-header>

  <nb-card-body>
    <div class="warning-messages" style="margin-top: 0;">
      <p class="text">آیا داشبورد با داده فعال شود؟</p>
    </div>

    <div class="col-10">
      <nb-radio-group
        name="connection"
        [(value)]="connectionType">

        <nb-radio
          *ngFor="let type of connectionTypes"
          [value]="type.value">
          {{ type.name }}
        </nb-radio>

      </nb-radio-group>
    </div>

    <div class="blue-box">
      <div class="blue-box-header mb-2">
        <morva-icons icon="activeInfoCircle"
                     class="cursor-pointer icon-24 ms-2">
        </morva-icons>
        <p class="text">اطلاع‌رسانی</p>
      </div>
      <p class="text px-2 me-4" *ngIf="connectionType=='withData'">
        در این مرحله امکان افزودن منبع داده جدید وجود ندارد.
         پیش از شروع فرایند، از موجود بودن منابع داده در فضای کاری اطمینان حاصل کنید.      
      </p>
      <p class="text px-2 me-4" *ngIf="connectionType=='withoutData'">
        در این حالت، داشبورد بدون منبع داده ساخته می‌شود. 
        چیدمان، استایل و تنظیمات کارت‌ها اعمال می‌شوند و امکان افزودن منبع داده در ادامه وجود دارد.
      </p>
  
      </div>
  </nb-card-body>

  <div class="nb-card-footer">
    <button nbButton
            class="confirm-button"
            (click)="continue()">
      ادامه
    </button>
  </div>
</nb-card>
